const SMUGMUG_SIZE_WIDTHS = {
  S: 400,
  M: 600,
  L: 800,
  XL: 1024,
  X2: 1280,
  X3: 1600,
  X4: 1920,
  X5: 2048,
};

export function buildSmugmugUrl(imageId, size = 'X5') {
  if (!imageId) return '';
  return `https://photos.smugmug.com/photos/i-${imageId}/0/${size}/i-${imageId}-${size}.jpg`;
}

// Lets <img srcSet> ask SmugMug for a size close to how large the image is
// actually displayed, instead of always downloading the largest variant.
export function buildSmugmugSrcSet(imageId, sizes = ['M', 'L', 'XL', 'X2', 'X3']) {
  if (!imageId) return '';
  return sizes
    .map((size) => `${buildSmugmugUrl(imageId, size)} ${SMUGMUG_SIZE_WIDTHS[size]}w`)
    .join(', ');
}
